export interface LoginInput {
  email: string;
  password: string;
  partnerId: string;
}

export interface VerifyEmailInput {
  token: string;
}

export interface VerifyEmailResponse {
  passwordToken?: string;
}

export interface ResetPasswordInput {
  token?: string;
  newPassword: string;
  passwordConfirmation: string;
}

export enum KnownHeaders {
  CFConnectingIP = 'cf-connecting-ip',
  CFCountry = 'cf-ipcountry',
  Host = 'host',
  Origin = 'origin',
  Referrer = 'referrer',
  SecChUA = 'sec-ch-ua',
  SecChUAMobile = 'sec-ch-ua-mobile',
  SecChUAPlatform = 'sec-ch-ua-platform',
  SecFetchDest = 'sec-fetch-dest',
  SecFetchMode = 'sec-fetch-mode',
  SecFetchSite = 'sec-fetch-site',
  SentryTrace = 'sentry-trace',
  UserAgent = 'user-agent',
}

export enum CustomHeaders {
  GCIPToken = 'x-gcip-token',
  GCIPTenantId = 'x-gcip-tenant-id',
  /**
   * Partner-level secret used for server-to-server API requests.
   * The header value carries the **raw** secret (never the hash) and must be
   * preserved by `sanitizeHeaders` middleware so Platform-API can validate it
   * when building the GraphQL context.
   */
  ApiKey = 'x-api-key',
}

export enum CookieKeys {
  LegacyAccessToken = 'access-token',
  LegacyRefreshToken = 'refresh-token',
}
